import { render, staticRenderFns } from "./invoiceDetail.vue?vue&type=template&id=a0863bfc&scoped=true"
import script from "./invoiceDetail.vue?vue&type=script&lang=js"
export * from "./invoiceDetail.vue?vue&type=script&lang=js"
import style0 from "./invoiceDetail.vue?vue&type=style&index=0&id=a0863bfc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0863bfc",
  null
  
)

export default component.exports